const initialState = {
  openCatalogues: [],
};

const documents = {
  namespaced: true,
  state: {
    openCatalogues: [...initialState.openCatalogues],
  },
  getters: {
    openCatalogues: (state) => state.openCatalogues,
  },
  mutations: {
    updateCatalogueState(state, id) {
      state.openCatalogues.includes(id)
        ? (state.openCatalogues = state.openCatalogues.filter((e) => e !== id))
        : state.openCatalogues.push(id);
    },
    resetCatalogueStates(state) {
      state.openCatalogues = initialState.openCatalogues;
    },
  },
  actions: {},
};

export default documents;
